import { useI18nContext } from '@/i18n/I18n';
import {
  IParentPermission,
  IPermission,
  ISubAccountPermission,
} from '@/services/types/apiManagement';

const transMap = {
  OptionsBlockTrade: 'BlockTrade',
  OptionsTrade: 'SpotTrade',
};

export const useHelper = () => {
  const [$t] = useI18nContext();

  const apiToString = (arr: string[]) => {
    let resStr = '';
    if (Array.isArray(arr)) {
      arr.forEach((item) => {
        resStr += `${$t(`per${item}`)} `;
      });
    }
    return resStr;
  };

  const strToArr = (mainTitle: string, str: string) => {
    const result = [];
    if (str) {
      result.push(`${mainTitle} - ${str}`);
    }
    return result;
  };

  function dealPermission(
    permission: IPermission,
    isSubAccount: boolean,
    readonly?: boolean,
  ) {
    let contractResult = '';
    let spotResult = '';
    let walletResult = '';
    let USDCResult = '';
    let copyTradingResult = '';
    let DerivativesRes = '';
    let exchangeResult = '';
    let blockTradeResult = '';
    let nftResult = '';
    let affiliateResult = '';
    let earnResult = '';
    let fiatP2pResult = '';
    let fiatBybitPayResult = '';
    /**母账号返回 */
    const {
      ContractTrade = [],
      Spot = [],
      Wallet = [],
      Options = [],
      CopyTrading = [],
      Derivatives = [],
      Exchange = [],
      BlockTrade = [],
      NFT = [],
      Affiliate = [],
      Earn = [],
      FiatP2P = [],
      FiatBybitPay = [],
    } = permission as IParentPermission;
    /**子账号返回 */
    const {
      contractTrade = [],
      spot = [],
      wallet = [],
      options = [],
      derivatives = [],
      exchange = [],
      blockTrade = [],
      copyTrading = [],
      earn = [],
    } = permission as ISubAccountPermission;

    for (let i = 0; i < contractTrade.length; i++) {
      if (contractTrade[i] === 'API_PERMISSION_POSITION') {
        contractTrade[i] = 'Position';
      } else if (contractTrade[i] === 'API_PERMISSION_ORDER') {
        contractTrade[i] = 'Order';
      } else if (contractTrade[i] === 'API_PERMISSION_BLOCK_TRADE') {
        contractTrade[i] = 'BlockTrade';
      }
    }

    for (let i = 0; i < options.length; i++) {
      if (options[i] === 'API_PERMISSION_OPTIONS_TRADE') {
        options[i] = 'OptionsTrade';
      }
    }

    for (let i = 0; i < spot.length; i++) {
      if (spot[i] === 'API_PERMISSION_SPOT_TRADE') {
        spot[i] = 'SpotTrade';
      }
    }
    // 处理子账号大宗交易国际化展示文案的key--perBlockTrade
    for (let i = 0; i < blockTrade.length; i++) {
      if (blockTrade[i] === 'API_PERMISSION_BLOCK_TRADE') {
        blockTrade[i] = 'BlockTrade';
      }
    }

    derivatives.forEach((v, i) => {
      if (v === 'API_PERMISSION_DERIVATIVES_TRADE') {
        derivatives[i] = 'DerivativesTrade';
      }
    });

    exchange.forEach((v, i) => {
      if (v === 'API_PERMISSION_EXCHANGE_HISTORY') {
        exchange[i] = 'ExchangeHistory';
      }
    });

    if (isSubAccount) {
      if (spot.length) {
        spot.forEach((item) => {
          spotResult += `${$t(`per${item}`)} `;
        });
      }
      if (blockTrade.length) {
        blockTrade.forEach((item) => {
          blockTradeResult += `${$t(`per${item}`)} `;
        });
      }
      if (contractTrade.length) {
        contractTrade.forEach((item) => {
          contractResult += `${$t(`per${item}`)} `;
        });
      }

      if (Array.isArray(options)) {
        options.forEach((item) => {
          USDCResult += `${$t(
            `per${transMap[item as 'OptionsBlockTrade' | 'OptionsTrade']}`,
          )} `;
        });
      }
      if (Array.isArray(wallet)) {
        wallet.forEach((item) => {
          if (item === 'API_PERMISSION_ACCOUNT_TRANSFER') {
            walletResult += `${$t('accountTransfer')} `;
          } else if (item === 'API_PERMISSION_SUBMEMBER_TRANSFER_LIST') {
            walletResult += `${$t('subaccountTransfer')} `;
          } else if (item === 'API_PERMISSION_SUBMEMBER_TRANSFER') {
            // 子账号没有母子账号划转权限，因此屏蔽
            walletResult += '';
          } else {
            walletResult += `${$t(item)} `;
          }
        });
      }
      if (Array.isArray(derivatives)) {
        derivatives.forEach((item) => {
          DerivativesRes += `${$t('Trade')} `;
        });
      }

      if (Array.isArray(exchange)) {
        exchange.forEach((item) => {
          exchangeResult += `${$t('exchangeHistoryCheck')} `;
        });
      }

      if (copyTrading.length) {
        copyTrading.forEach((item) => {
          if (item === 'API_PERMISSION_COPY_TRADING') {
            copyTradingResult += `${$t(`perCopyTrading`)} `;
          }
        });
      }

      if (earn?.length) {
        earn.forEach((item: string) => {
          if (item === 'API_PERMISSION_EARN') {
            earnResult += `${$t('flexibleSaving')} `;
          }
        });
      }
    } else {
      contractResult = apiToString(ContractTrade);

      if (Array.isArray(Options)) {
        Options.forEach((item) => {
          USDCResult += `${$t(
            `per${transMap[item as 'OptionsBlockTrade' | 'OptionsTrade']}`,
          )} `;
        });
      }

      if (Spot.length) {
        Spot.forEach((item) => {
          spotResult += `${$t(`per${item}`)} `;
        });
      }
      if (CopyTrading.length) {
        CopyTrading.forEach((item) => {
          contractResult += `${$t(`per${item}`)} `;
        });
      }

      spotResult = apiToString(Spot);

      copyTradingResult = apiToString(CopyTrading);

      blockTradeResult = apiToString(BlockTrade);

      if (Array.isArray(Affiliate)) {
        Affiliate.forEach((item) => {
          affiliateResult += $t(item);
        });
      }

      if (Array.isArray(Earn)) {
        Earn.forEach((item: string) => {
          if (item === 'Earn') {
            earnResult += `${$t('flexibleSaving')} `;
          }
        });
      }

      if (Array.isArray(FiatP2P)) {
        FiatP2P.forEach((item: string) => {
          if (item === 'FiatP2POrder') {
            fiatP2pResult += `${$t('fiatTradeP2POrder')} `;
          }
          if (item === 'Advertising') {
            fiatP2pResult += `${$t('fiatTradeP2PAds')} `;
          }
        });
      }

      if (Array.isArray(FiatBybitPay)) {
        FiatBybitPay.forEach((item: string) => {
          if (item === 'FaitPayOrder') {
            fiatBybitPayResult += `${$t('fiatTradePayOrder')} `;
          }
        });
      }

      // 钱包权限，子账号和母账号key一致
      if (Array.isArray(Wallet)) {
        Wallet.forEach((item) => {
          if (item === 'AccountTransfer') {
            walletResult += `${$t('accountTransfer')} `;
          } else if (item === 'SubMemberTransfer') {
            walletResult += `${$t('subaccountTransfer')} `;
          } else if (item === 'Withdraw') {
            walletResult += $t('doWithDraw');
          } else {
            walletResult += `${$t(item)} `;
          }
        });
      }

      if (Array.isArray(Derivatives)) {
        Derivatives.forEach((item) => {
          DerivativesRes += `${$t('Trade')} `;
        });
      }

      if (Array.isArray(Exchange)) {
        Exchange.forEach(() => {
          exchangeResult += `${$t('exchangeHistoryCheck')} `;
        });
      }

      if (Array.isArray(NFT)) {
        NFT.forEach(() => {
          nftResult += `${$t('perNFT')} `;
        });
      }
    }

    let result: string[] = [];
    result = result.concat(
      strToArr($t('Contracts'), contractResult),
      strToArr($t('USDCContract'), USDCResult),
      strToArr($t('Derivatives API V3'), DerivativesRes),
      strToArr($t('spot'), spotResult),
      strToArr($t('perBlockTrade'), blockTradeResult),
      strToArr($t('CopyTrading'), copyTradingResult),
      strToArr($t('Wallet'), walletResult),
      strToArr($t('assetsExchange.exchange'), exchangeResult),
      strToArr('NFT', nftResult),
      strToArr('Affiliate', affiliateResult),
      strToArr($t('bybitSaving'), earnResult),
      strToArr($t('P2P'), fiatP2pResult),
      strToArr($t('BybitPay'), fiatBybitPayResult),
    );

    let resultStr = result.join(' , ');

    if (readonly) resultStr = `${resultStr} ${$t('read_only')}`;
    return resultStr;
  }

  return { dealPermission };
};

export const commonProcessResult = ({
  riskToken,
  res,
  onSuccess,
  onReject,
  onShowSecurity,
  toggle2faModal,
}: {
  riskToken: string;
  res: any;
  onSuccess: () => void;
  onReject: () => void;
  onShowSecurity: (riskToken: string) => void;
  toggle2faModal?: () => void;
}) => {
  if (riskToken || res?.result?.riskTokenType === 'pass') {
    onSuccess?.();
  } else {
    if (res?.result?.riskToken === '') {
      toggle2faModal?.();
    } else {
      if (
        res?.result?.riskTokenType &&
        res?.result?.riskTokenType === 'reject'
      ) {
        onReject?.();
      } else {
        onShowSecurity?.(res?.result?.riskToken);
      }
    }
  }
};
